/**
 * Created by Markus on 15.6.2015.
 * In this case sections are considered the level 1 pages that have children (1 or more)
 */

define('helperNavigation-isSection1stPage',[],function() {
    'use strict';

    var isSection1stPage = function(ID, arr, level) {
        var res,
            is1st = false;

        if (!ID || !Array.isArray(arr)) {
            return null;
        }

        arr = [].concat(arr);
        if (!level) {
            level = 1;
        }

        if(arr.length > 0) {
            is1st = (
                arr.some(function (entity, i) {
                    if (entity.hasOwnProperty('contentEntityId') && entity.contentEntityId === ID) {
                        if (level === 1) {
                            // main level page
                            return false;
                        } else if (i === 0) {
                            return true;
                        }

                    } else if (entity.hasOwnProperty('children') && Array.isArray(entity.children) && entity.children.length && level === 1) {
                        res = isSection1stPage(ID, entity.children, level + 1);
                        if (res) {
                            return res;
                        }
                    }
                })
            ) ? true: false;
        }

        return is1st;
    };

    return isSection1stPage;

});

